'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Image as AImage } from '@radix-ui/react-avatar';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const AvatarImage = forwardRef(({ className, ...props }, ref) => (_jsx(AImage, { ref: ref, className: cn('aspect-square h-full w-full', className), ...props })));
AvatarImage.displayName = AImage.displayName;
export { AvatarImage };
